import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderCancelAutorenewErrorModal = () => openPopupHelper({ popupName: popupNames.CANCEL_AUTORENEW_ERROR_MODAL });
